import { action, makeObservable, observable } from 'mobx';

import i18n from 'src/i18n';
import { LANGUAGES, LOCKED_LANG } from 'src/shared/constants/languages';

export class LanguageStore {
  @observable language: LANGUAGES;
  @observable isLanguageSwitcherHidden = false;

  constructor() {
    this.language = i18n.language in LANGUAGES ? (i18n.language as LANGUAGES) : LANGUAGES.en;

    makeObservable(this);
  }

  private _setLanguage(lan: LANGUAGES) {
    this.language = lan;
  }

  @action.bound
  toggle(): void {
    this._setLanguage(this.language === LANGUAGES.ru ? LANGUAGES.en : LANGUAGES.ru);
    i18n.changeLanguage(this.language);
  }

  @action.bound
  init(): void {
    if (LOCKED_LANG) {
      i18n.changeLanguage(LOCKED_LANG);
      this._setLanguage(LOCKED_LANG);
      this.isLanguageSwitcherHidden = true;
    }
  }
}
